module.exports = __webpack_public_path__ + "static/hyperv_25.9928aefa.jpg";